import i18n from '../i18n/config';
import { useTranslation } from 'react-i18next';
// Uso del Sistema — Solo Arsenal. Adopción de TODOS los clientes/módulos.
import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, Grid, Card, CardContent, Paper, Chip, Stack, IconButton, Tooltip,
  CircularProgress, TextField, MenuItem, Button, Table, TableBody, TableCell, TableHead,
  TableRow, TableContainer, Dialog, DialogTitle, DialogContent, LinearProgress,
} from '@mui/material';
import {
  Refresh as RefreshIcon, Download as DownloadIcon, Business as BusinessIcon,
  Visibility as ViewIcon, Warning as RiskIcon, TrendingUp as ScoreIcon, Close as CloseIcon,
} from '@mui/icons-material';
import { api } from '../services/api';
import { useNotification } from '../components/common/GlobalNotifications';

const STATUS = {
  excelente: { label: i18n.t('hardcoded.pages_systemusagepage.excelente'), color: '#2e7d32' },
  buen_uso: { label: i18n.t('hardcoded.pages_systemusagepage.buen_uso'), color: '#558b2f' },
  activo: { label: i18n.t('common.active'), color: '#0288d1' },
  bajo_uso: { label: i18n.t('hardcoded.pages_systemusagepage.bajo_uso'), color: '#ed6c02' },
  sin_uso: { label: i18n.t('hardcoded.pages_systemusagepage.sin_uso'), color: '#9e9e9e' },
};
const RISK = { en_riesgo: { label: i18n.t('hardcoded.pages_systemusagepage.en_riesgo'), color: '#d32f2f' }, atencion: { label: i18n.t('hardcoded.pages_chatanalyticspage.atencion'), color: '#ed6c02' }, ok: { label: i18n.t('hardcoded.pages_systemusagepage.ok'), color: '#2e7d32' }, sin_uso: { label: i18n.t('hardcoded.pages_systemusagepage.sin_uso'), color: '#9e9e9e' } };
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: '2-digit' }) : '—');

const StatusChip = ({ value }) => {
  const { t } = useTranslation(); const s = STATUS[value] || STATUS.sin_uso; return <Chip size="small" label={s.label} sx={{ bgcolor: `${s.color}22`, color: s.color, fontWeight: 700, height: 22 }} />; };
const ScoreBar = ({ score }) => {
  const { t } = useTranslation();
  const c = score > 70 ? '#2e7d32' : score > 40 ? '#0288d1' : score > 20 ? '#ed6c02' : '#9e9e9e';
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 110 }}>
      <Box sx={{ flex: 1 }}><LinearProgress variant="determinate" value={score} sx={{ height: 8, borderRadius: 4, '& .MuiLinearProgress-bar': { bgcolor: c } }} /></Box>
      <Typography variant="caption" fontWeight={800} sx={{ color: c, width: 28 }}>{score}</Typography>
    </Stack>
  );
};
const Kpi = ({ icon, label, value, color = '#1a1a1a' }) => (
  <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, height: '100%' }}>
    <CardContent sx={{ py: 1.75 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>{icon}
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</Typography>
      </Stack>
      <Typography variant="h5" sx={{ fontWeight: 800, color, lineHeight: 1 }}>{value}</Typography>
    </CardContent>
  </Card>
);

function CompanyDetailDialog({ companyId, days, onClose }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let ok = true;
    api.systemUsage.company(companyId, days).then((r) => { if (ok) setData(r.data); }).catch(() => {}).finally(() => ok && setLoading(false));
    return () => { ok = false; };
  }, [companyId, days]);
  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BusinessIcon color="primary" /> {data?.company?.name || t('navbar.company')}
        <Box sx={{ flex: 1 }} /><IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box> : data && (
          <Stack spacing={2}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                <Box sx={{ minWidth: 160 }}><Typography variant="caption" color="text.secondary">{t('hardcoded.pages_systemusagepage.score_de_adopcion')}</Typography><ScoreBar score={data.adoption.score} /></Box>
                <StatusChip value={data.adoption.status} />
                <Chip size="small" variant="outlined" label={i18n.t('hardcoded.pages_systemusagepage.onboarding_status', { onboarding_status: data.adoption.onboarding_status })} />
                <Chip size="small" label={(RISK[data.adoption.risk_status] || RISK.ok).label} sx={{ bgcolor: `${(RISK[data.adoption.risk_status] || RISK.ok).color}22`, color: (RISK[data.adoption.risk_status] || RISK.ok).color, fontWeight: 700 }} />
                <Chip size="small" variant="outlined" label={t('hardcoded.pages_systemusagepage.ultimo_login_fmtdatametricsl', { fmtdatametricsl: fmt(data.metrics.last_login) })} />
              </Stack>
            </Paper>

            {data.adoption.recommendations?.length > 0 && (
              <Paper variant="outlined" sx={{ p: 2, borderColor: 'rgba(211,47,47,0.25)' }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>{t('hardcoded.pages_systemusagepage.plan_de_accion_sugerido')}</Typography>
                <Stack spacing={0.75}>
                  {data.adoption.recommendations.map((r, i) => (
                    <Stack key={i} direction="row" spacing={1} alignItems="center">
                      <Chip size="small" label={r.severity === 'critical' ? t('hardcoded.pages_systemusagepage.critico') : r.severity === 'warning' ? t('hardcoded.pages_chatanalyticspage.atencion') : t('common.info')}
                        color={r.severity === 'critical' ? 'error' : r.severity === 'warning' ? 'warning' : 'info'} sx={{ height: 18, fontSize: 10 }} />
                      <Typography variant="body2">{r.text}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Paper>
            )}

            <Typography variant="subtitle2" fontWeight={700}>{t('hardcoded.pages_systemusagepage.uso_por_modulo')}</Typography>
            <Grid container spacing={1.5}>
              {data.modules.map((md) => (
                <Grid item xs={6} sm={4} md={3} key={md.key}>
                  <Paper variant="outlined" sx={{ p: 1.5, opacity: md.used ? 1 : 0.6 }}>
                    <Typography variant="caption" color="text.secondary">{md.label}</Typography>
                    <Typography variant="h6" fontWeight={800}>{md.count}</Typography>
                    <Chip size="small" label={md.used ? t('hardcoded.pages_systemusagepage.en_uso') : t('hardcoded.pages_systemusagepage.sin_uso')} color={md.used ? 'success' : 'default'} sx={{ height: 18, fontSize: 10 }} />
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>{fmt(md.last)}</Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            <Typography variant="subtitle2" fontWeight={700}>{i18n.t('hardcoded.pages_systemusagepage.usuarios')}{data.users.length})</Typography>
            <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 300 }}>
              <Table size="small" stickyHeader>
                <TableHead><TableRow sx={{ '& th': { fontWeight: 700, bgcolor: '#fafafa' } }}>
                  <TableCell>{t('audit.table.user')}</TableCell><TableCell>{i18n.t('users.table.role')}</TableCell><TableCell align="right">{t('common.actions')}</TableCell>
                  <TableCell>{t('hardcoded.pages_systemusagepage.ultimo_login')}</TableCell><TableCell>{i18n.t('gps.table.status')}</TableCell>
                </TableRow></TableHead>
                <TableBody>
                  {data.users.map((u) => (
                    <TableRow key={u.user_id} hover>
                      <TableCell><Typography variant="body2" fontWeight={600}>{u.name}</Typography><Typography variant="caption" color="text.secondary">{u.email}</Typography></TableCell>
                      <TableCell>{u.role}</TableCell><TableCell align="right">{u.actions}</TableCell>
                      <TableCell>{fmt(u.last_login)}</TableCell>
                      <TableCell><Chip size="small" label={u.status} variant="outlined" sx={{ height: 18, fontSize: 10 }} /></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default function SystemUsagePage() {
  const { t } = useTranslation();
  const { showError } = useNotification();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  const [status, setStatus] = useState('all');
  const [search, setSearch] = useState('');
  const [detailId, setDetailId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.systemUsage.overview(days); setData(r.data); }
    catch (e) { showError(e?.response?.data?.detail || t('hardcoded.pages_systemusagepage.error_cargando_uso_del_sistema')); }
    finally { setLoading(false); }
  }, [days, showError]);
  useEffect(() => { load(); }, [load]);

  const kpis = data?.kpis || {};
  const companies = (data?.companies || []).filter((c) => (
    (status === 'all' || c.status === status)
    && (!search || (c.company_name || '').toLowerCase().includes(search.toLowerCase()))
  ));

  const doExport = async () => {
    const { url, token } = api.systemUsage.exportUrl(days);
    try {
      const resp = await fetch(url, { headers: { Authorization: t('hardcoded.components_common_imageupload.bearer_token', { token: token }) } });
      const blob = await resp.blob();
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = t('hardcoded.pages_systemusagepage.uso_del_sistemacsv');
      document.body.appendChild(a); a.click(); a.remove();
    } catch (e) { showError(t('hardcoded.pages_systemusagepage.no_se_pudo_exportar')); }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" sx={{ mb: 2, gap: 1 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 800, color: 'primary.main' }}>{t('hardcoded.components_common_sidebar.uso_del_sistema')}</Typography>
          <Typography variant="body2" color="text.secondary">{t('hardcoded.pages_systemusagepage.adopcion_de_aps_por_cliente')}</Typography>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <TextField select size="small" label={t('hardcoded.pages_billinginvoicespage.periodo')} value={days} onChange={(e) => setDays(Number(e.target.value))} sx={{ minWidth: 130 }}>
            <MenuItem value={7}>{t('hardcoded.pages_systemusagepage.7_dias')}</MenuItem><MenuItem value={30}>{t('hardcoded.pages_systemusagepage.30_dias')}</MenuItem><MenuItem value={90}>{t('hardcoded.pages_systemusagepage.90_dias')}</MenuItem>
          </TextField>
          <Button size="small" startIcon={<DownloadIcon />} onClick={doExport}>{t('hardcoded.pages_systemusagepage.csv')}</Button>
          <Tooltip title={t('audit.actions.UPDATE')}><span><IconButton color="primary" onClick={load} disabled={loading}><RefreshIcon /></IconButton></span></Tooltip>
        </Stack>
      </Stack>

      {loading && <Box sx={{ textAlign: 'center', py: 5 }}><CircularProgress /></Box>}

      {!loading && data && (
        <>
          <Grid container spacing={1.5} sx={{ mb: 2 }}>
            <Grid item xs={6} md={2}><Kpi icon={<BusinessIcon fontSize="small" color="primary" />} label={t('hardcoded.pages_chatanalyticspage.empresas')} value={kpis.companies_total ?? 0} /></Grid>
            <Grid item xs={6} md={2}><Kpi icon={<ScoreIcon fontSize="small" color="success" />} label={t('hardcoded.pages_systemusagepage.activas_7d')} value={kpis.companies_active_7d ?? 0} color="#2e7d32" /></Grid>
            <Grid item xs={6} md={2}><Kpi icon={<ScoreIcon fontSize="small" />} label={t('hardcoded.pages_systemusagepage.score_prom')} value={kpis.avg_adoption_score ?? 0} /></Grid>
            <Grid item xs={6} md={2}><Kpi icon={<RiskIcon fontSize="small" color="error" />} label={t('hardcoded.pages_systemusagepage.en_riesgo')} value={kpis.companies_at_risk ?? 0} color="#d32f2f" /></Grid>
            <Grid item xs={6} md={2}><Kpi icon={<BusinessIcon fontSize="small" />} label={t('hardcoded.pages_systemusagepage.sin_uso')} value={kpis.companies_no_use ?? 0} color="#9e9e9e" /></Grid>
            <Grid item xs={6} md={2}><Kpi icon={<BusinessIcon fontSize="small" color="warning" />} label={t('hardcoded.pages_systemusagepage.onboarding_incompl')} value={kpis.companies_onboarding_incomplete ?? 0} color="#ed6c02" /></Grid>
          </Grid>

          <Paper variant="outlined" sx={{ p: 1.5, mb: 2, borderRadius: 2 }}>
            <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="center">
              <TextField size="small" placeholder={t('hardcoded.pages_systemusagepage.buscar_empresa')} value={search} onChange={(e) => setSearch(e.target.value)} sx={{ minWidth: 220 }} />
              <TextField select size="small" label={t('gps.table.status')} value={status} onChange={(e) => setStatus(e.target.value)} sx={{ minWidth: 160 }}>
                <MenuItem value="all">{i18n.t('hardcoded.components_alarmprofiles_assignmentstable.todos')}</MenuItem>
                {Object.entries(STATUS).map(([k, v]) => <MenuItem key={k} value={k}>{v.label}</MenuItem>)}
              </TextField>
              <Typography variant="caption" color="text.secondary">{companies.length} {i18n.t('hardcoded.pages_systemusagepage.empresas')}</Typography>
            </Stack>
          </Paper>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead><TableRow sx={{ '& th': { fontWeight: 700, bgcolor: '#fafafa' } }}>
                <TableCell>{i18n.t('navbar.company')}</TableCell><TableCell sx={{ minWidth: 130 }}>{t('hardcoded.pages_chatanalyticspage.adopcion')}</TableCell><TableCell>{i18n.t('gps.table.status')}</TableCell>
                <TableCell align="right">{i18n.t('users.title')}</TableCell><TableCell align="right">{t('vehicles.title')}</TableCell>
                <TableCell align="right">{i18n.t('hardcoded.pages_systemusagepage.tickets_res')}</TableCell><TableCell align="right">{i18n.t('hardcoded.components_common_sidebar.chat')}</TableCell><TableCell align="right">IA</TableCell>
                <TableCell>{t('hardcoded.pages_systemusagepage.ult_actividad')}</TableCell><TableCell>{t('hardcoded.pages_systemusagepage.recomendacion')}</TableCell><TableCell align="right"></TableCell>
              </TableRow></TableHead>
              <TableBody>
                {companies.map((c) => (
                  <TableRow key={c.company_id} hover>
                    <TableCell sx={{ fontWeight: 600 }}>{c.company_name}</TableCell>
                    <TableCell><ScoreBar score={c.adoption_score} /></TableCell>
                    <TableCell><StatusChip value={c.status} />{c.risk_status === 'en_riesgo' && <Chip size="small" label={t('hardcoded.components_tickets_ticketaianalysiscard.riesgo')} color="error" sx={{ ml: 0.5, height: 18, fontSize: 10 }} />}</TableCell>
                    <TableCell align="right">{c.active_users}/{c.users}</TableCell>
                    <TableCell align="right">{c.vehicles}</TableCell>
                    <TableCell align="right">{c.tickets_resolved}</TableCell>
                    <TableCell align="right">{c.chat_messages}</TableCell>
                    <TableCell align="right">{c.ai_messages}</TableCell>
                    <TableCell>{fmt(c.last_activity)}</TableCell>
                    <TableCell sx={{ maxWidth: 260 }}><Typography variant="caption" color="text.secondary">{c.recommendation}</Typography></TableCell>
                    <TableCell align="right"><Tooltip title={t('hardcoded.components_alarmprofiles_profilecard.ver_detalle')}><IconButton size="small" onClick={() => setDetailId(c.company_id)}><ViewIcon fontSize="small" /></IconButton></Tooltip></TableCell>
                  </TableRow>
                ))}
                {companies.length === 0 && <TableRow><TableCell colSpan={11}><Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>{t('hardcoded.pages_systemusagepage.sin_resultados')}</Typography></TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      {detailId && <CompanyDetailDialog companyId={detailId} days={days} onClose={() => setDetailId(null)} />}
    </Box>
  );
}
